<template>
  <section class="trial-of-descendant-of-moab-wrap" v-parallax v-slide-up-in>
    <v-page :background="theme.colors.cyan">
      <v-sub-chapter-index-page
        :pageData="pageDataItem.page0.data"
        v-slide-up-in-stage="1"
      />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        v-slide-up-in-stage="2"
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/page1ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page1.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page2.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page3.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/page4ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page4.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/page5ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page5.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/page6ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page6.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page7.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page8.data.content" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page9.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/page8ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page10.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/page7ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page11.data"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-full-screen-songs-player
        :data="pageDataItem.page12.data"
        bg="images/common/hymnsPosters/six-trials-of-God-s-judgment-work-5.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry bg-color="cyan" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
    };
  },
  created() {
    this.pageDataItem = this.schema["trial-of-descendants-of-moab"].item;
  },
};
</script>
